module.exports = __webpack_public_path__ + "static/media/3.052017c5.png";